import { render, staticRenderFns } from "./NotesModal.vue?vue&type=template&id=62db867c&scoped=true"
import script from "./NotesModal.vue?vue&type=script&lang=js"
export * from "./NotesModal.vue?vue&type=script&lang=js"
import style0 from "./NotesModal.vue?vue&type=style&index=0&id=62db867c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db867c",
  null
  
)

export default component.exports